import { createFileRoute } from '@tanstack/react-router';

import { DomainsTable } from '../features/supply/domains/components/DomainsTable';
import { domainsRouteSearchSchema } from '../features/supply/domains/domainsRouteSearch';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/domains')({
  validateSearch: domainsRouteSearchSchema,
  component: PublisherDomainsRoute,
});

function PublisherDomainsRoute() {
  const { publisherId } = Route.useParams();
  return <DomainsTable publisherId={publisherId} />;
}
